// extracted by mini-css-extract-plugin
module.exports = {"machine":"Machine_machine__12eCw","prizeWrap":"Machine_prizeWrap__2_iSq","prize":"Machine_prize__lPUJP","lotteryBtn":"Machine_lotteryBtn__3a7Mz"};